import * as React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

export default function Alerta({ severity = "success", title, children, sx, ...rest }) {
  return (
    <Stack sx={{ width: '100%', ...sx }} {...rest}>
      <Alert severity={severity}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {children}
      </Alert>
    </Stack>
  );
}